import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Table } from "@/features/Table";
import { getDownloadCenterColumns, TDowloadCenter } from "./columns";
import { FilterDowloadCenter } from "./filter";

export default function DowloadCenterTable({
  client,
  table_name,
}: {
  client: string;
  table_name: string;
}) {
  const { t, i18n } = useTranslation();
  const columns = useMemo(
    () => getDownloadCenterColumns(t),
    [t, i18n.language],
  );

  return (
    <Table<TDowloadCenter, any>
      label={t("download_center.title", { defaultValue: "Download Center" })}
      client={client}
      table_name={table_name}
      columns={columns}
      filter={<FilterDowloadCenter />}
      download_button={false}
      disable_translations_request={true}
      columnVisibilityInit={{
        id: false,
      }}
    />
  );
}
